import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { spacing, colors, borderRadius, breakpoints, utility } = useTheme();

  return {
    base: css`
      padding-top: 2px;
      display: grid;
      flex-wrap: wrap;
      margin: -${spacing.xs} 0 0 -${spacing.xs};
      margin-top: 16px;
      margin-left: 0;
      height: calc(61px * 7); /* Adjust height for exactly 7 options */
      overflow: auto;
      scroll-behavior: smooth;
      scrollbar-width: none;

      @media (min-width: 996px) and (max-width: 1600px) {
        height: calc(61px * 7); /* Adjust height for exactly 7 options */
      }
      @media (min-width: 760px) and (max-width: 996px) {
        height: calc(61px * 6); /* Adjust height for exactly 6 options */
      }
      @media (max-width: 767px) {
        height: calc(48px * 5); /* Adjust height for exactly 4 options */
      }
    `,
    answer: isChecked => css`
      display: block;
      padding: ${spacing.xs};
      background-color: ${colors.white};
      color: ${colors.white};
      cursor: pointer;
      border-radius: ${borderRadius.m};
      border: ${borderRadius.s} solid ${colors.white};
      padding: 0.5rem 1rem;
      background-color: transparent;
      text-align: center;
      height: 48px;
      align-content: center;
      font-size: 18px;
      font-weight: 700;

      ${isChecked &&
      css`
        background-color: ${colors.white};
        color: ${colors.navy};
      `}

      &:focus-visible:not(:hover) {
        outline: none;
        color: ${colors.border_black};
        border: 2px solid ${colors.border_black};
        background-color: ${colors.skip_yellow};
        text-decoration: underline;
        border-radius: ${borderRadius.m};
      }

      @media (min-width: 760px) and (max-width: 996px) {
        width: 327px;
      }

      ${breakpoints.l} {
        padding: ${spacing.xs} ${spacing.s};
        width: 391px;
      }
    `,
    label: css`
      width: 327px;
      height: 61px;

      & > input[type='checkbox']:focus-visible + span {
        outline: none;
        color: ${colors.border_black};
        border: 2px solid ${colors.border_black};
        background-color: ${colors.skip_yellow};
        text-decoration: underline;
      }

      & > input[type='checkbox']:checked:focus-visible + span {
        border: 2px solid ${colors.border_black};
        background-color: ${colors.skip_yellow};
        color: ${colors.border_black};
        text-decoration: underline;
      }
      @media (hover: hover) and (pointer: fine) {
        & > input[type='checkbox']:hover + span {
          background-color: transparent;
          color: ${colors.white};
          font-weight: 700;
        }
      }

      ${breakpoints.xl} {
        width: 391px;
        height: 61px;

        & > input[type='checkbox']:hover + span {
          background-color: ${colors.white};
          color: ${colors.navy};
          font-weight: 700;
        }
      }
    `,
    buttonNext: arrowContext => css`
      font-family: 'FS Dillon';
      width: 327px;
      height: 48px;
      background-color: ${colors.red};
      color: ${colors.white};
      border: 1px ${colors.red} solid;
      border-radius: 4px;
      margin-top: 10px;
      font-size: 16px;
      &:focus-visible {
        outline: none;
        color: ${colors.border_black};
        border: 2px solid ${colors.border_black};
        background-color: ${colors.skip_yellow};
        text-decoration: underline;
      }

      ${arrowContext === false &&
      css`
        background-color: ${colors.border_grey};
        color: ${colors.next_grey};
        border: 1px ${colors.border_grey} solid;
        cursor: initial;
      `}

      ${arrowContext === true &&
      css`
        background-color: ${colors.red};
        color: ${colors.white};
        cursor: pointer;
      `}

      ${breakpoints.l} {
        width: 391px;
      }
    `,
    checkbox: css`
      ${utility.checkboxHidden};
      outline: none;
    `,
    fade: css`
      transition: opacity 0.5s;
    `,
  };
};
